import { UserDataModel } from 'common/models';
import { useTracking } from 'common/utils';
import { useState } from 'react';

const useProfileButton = () => {
  const [isOpenProfileDrawer, setIsOpenProfileDrawer] = useState(false);
  const { track } = useTracking();

  const handleOnProfileButtonClick = () => {
    track('Profile Button - Clicked to open profile drawer');
    setIsOpenProfileDrawer(true);
  };

  const handleOnCloseProfileDrawer = () => {
    track('Profile Button - Clicked to close profile drawer');
    setIsOpenProfileDrawer(false);
  };

  const handleGetProfileName = (user: Partial<UserDataModel>) => {
    if (!user) return '';
    if (user.first_name && user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    if (user.name) {
      return user.name;
    }
    return user.email ?? '';
  };

  const handleGetProfileInitials = (user: Partial<UserDataModel>) => {
    if (!user) return '';
    const firstInitial = user.first_name?.charAt(0).toUpperCase() ?? '';
    const lastInitial = user.last_name?.charAt(0).toUpperCase() ?? '';
    return `${firstInitial}${lastInitial}`;
  };

  return {
    isOpenProfileDrawer,
    handleOnProfileButtonClick,
    handleOnCloseProfileDrawer,
    handleGetProfileName,
    handleGetProfileInitials,
  };
};

export { useProfileButton };
